export default {
  async loadStoplightConcernOptions (context, scotswork) {
    const code = scotswork ? '66e0686d33c451360c9041ba' : '63d4869fe3c9882700f4675d'
    const { options } = await this.$feathers.service('forms/select-options').get(code)
    return options.filter(({ disabled }) => !disabled).map(({ text, value }) => { return { text, value } }).map(({ text }) => text)
  }
}
